import { OPEN_API_TEST, OPEN_API_PRO, BASE_URL } from "@/constants/index";

export function returnInboundApi() {
  const apiUrlTest = "/gateway/edi/product/query"; //测试环境接口地址
  // const isCn = (localStorage.getItem("lang") || "CN") === "CN";
  return {
    //当前请求URL
    apiBaseUrl: BASE_URL + `${apiUrlTest}`,

    onlineData: {
      // 接口描述
      apiDesc: "apiDocDesc.inboundordercallbackapiDesc",
      //接口地址
      testApi: `${OPEN_API_TEST}${apiUrlTest}`,
      proApi: `${OPEN_API_PRO}${apiUrlTest}`,
      infos: [],
      //参数描述  START
      postDataList: [
        //   请求头参数
        {
          title: "onlineDoc.请求参数",
          value: [
            {
              name: "requestId",
              type: "varchar(50)",
              require: "Y",
              normal: "",
              describe: "apiDocDesc.requestIdDesc159"
            },
            {
              name: "warehouseCode",
              type: "varchar(50)",
              require: "Y",
              normal: "",
              describe: "apiDocDesc.warehouseCodeDesc160"
            },
            {
              name: "customerId",
              type: "varchar(50)",
              require: "Y",
              normal: "",
              describe: "apiDocDesc.customerIdDesc161"
            },
            {
              name: "storerKey",
              type: "varchar(50)",
              require: "N",
              normal: "",
              describe: "apiDocDesc.storerKeyDesc162"
            },
            {
              name: "entryOrderCode",
              type: "varchar(50)",
              require: "Y",
              normal: "",
              describe: "apiDocDesc.entryOrderCodeDesc163"
            },
            {
              name: "entryOrderId",
              type: "varchar(50)",
              require: "Y",
              normal: "",
              describe: "apiDocDesc.entryOrderIdDesc164"
            },
            {
              name: "returnWaybillCode",
              type: "varchar(50)",
              require: "N",
              normal: "",
              describe: "apiDocDesc.entryOrderIdDesc1641"
            },
            {
              name: "wmsCreated",
              type: "INT",
              require: "N",
              normal: "",
              describe: "apiDocDesc.wmsCreatedDesc1642"
            },
            {
              name: "deliveryOrderCode",
              type: "varchar(50)",
              require: "N",
              normal: "",
              describe: "apiDocDesc.deliveryOrderCodeDesc1643"
            },
            {
              name: "platformNumber",
              type: "varchar(50)",
              require: "N",
              normal: "",
              describe: "apiDocDesc.platformNumberDesc1644"
            },
            {
              name: "sourceSystem",
              type: "varchar(50)",
              require: "N",
              normal: "",
              describe: "apiDocDesc.sourceSystemDesc165"
            },
            {
              name: "outBizNo",
              type: "varchar(50)",
              require: "N",
              normal: "",
              describe: "apiDocDesc.outBizNoDesc166"
            },
            {
              name: "orderType",
              type: "INT",
              require: "Y",
              normal: "",
              describe: "apiDocDesc.orderTypeDesc167"
            },
            {
              name: "confirmType",
              type: "varchar(200)",
              require: "Y",
              normal: "",
              describe: "apiDocDesc.confirmTypeDesc168"
            },
            {
              name: "remark",
              type: "varchar",
              require: "N",
              normal: "",
              describe: "apiDocDesc.remarkDesc169"
            },
            {
              name: "status",
              type: "TIME",
              require: "Y",
              normal: "",
              describe: "apiDocDesc.statusDesc170"
            },
            {
              name: "operateTime",
              type: "json",
              require: "Y",
              normal: "",
              describe: "apiDocDesc.operateTimeDesc171"
            },
            {
              name: "reserved1",
              type: "",
              require: "N",
              normal: "",
              describe: "apiDocDesc.reserved1Desc172"
            },
            {
              name: "orderLines",
              type: "varchar(50)",
              require: "",
              normal: "",
              describe: "apiDocDesc.orderLinesDesc173",
              children: [
                {
                  name: "LineNo",
                  type: "varchar(50)",
                  require: "N",
                  normal: "",
                  describe: "apiDocDesc.LineNoDesc174"
                },
                {
                  name: "itemCode",
                  type: "varchar(50)",
                  require: "Y",
                  normal: "",
                  describe: "apiDocDesc.itemCodeDesc175"
                },
                {
                  name: "itemName",
                  type: "int",
                  require: "Y",
                  normal: "",
                  describe: "apiDocDesc.itemNameDesc176"
                },
                {
                  name: "quantity",
                  type: "int",
                  require: "Y",
                  normal: "",
                  describe: "apiDocDesc.quantityDesc177"
                },
                {
                  name: "actualQty",
                  type: "varchar(50)",
                  require: "Y",
                  normal: "",
                  describe: "apiDocDesc.actualQtyDesc178"
                },
                {
                  name: "inventoryType",
                  type: "date",
                  require: "Y",
                  normal: "",
                  describe: "apiDocDesc.inventoryTypeDesc179"
                },
                {
                  name: "productDate",
                  type: "date",
                  require: "N",
                  normal: "",
                  describe: "apiDocDesc.productDateDesc180"
                },
                {
                  name: "expireDate",
                  type: "varchar(50)",
                  require: "N",
                  normal: "",
                  describe: "apiDocDesc.expireDateDesc181"
                },
                {
                  name: "produceCode",
                  type: "varchar(50)",
                  require: "N",
                  normal: "",
                  describe: "apiDocDesc.produceCodeDesc182"
                },
                {
                  name: "batchCode",
                  type: "json",
                  require: "N",
                  normal: "",
                  describe: "apiDocDesc.batchCodeDesc183"
                },
                {
                  name: "reserved1",
                  type: "",
                  require: "N",
                  normal: "",
                  describe: "apiDocDesc.reserved1Desc184",
                },
                {
                      name: "snList",
                      type: "Array",
                      require: "N",
                      normal: "",
                      describe: "apiDocDesc.reserved1Desc1841",
                      children: [
                        {
                          name: "sn",
                          type: "String[]",
                          require: "N",
                          normal: "",
                          describe: "apiDocDesc.reserved1Desc18411"
                        }
                      ]
                    },
                {
                  name: "batches",
                  type: "int",
                  require: "",
                  normal: "",
                  describe: "apiDocDesc.batchesDesc185",
                  children: [
                    {
                      name: "actualQty",
                      type: "varchar(50)",
                      require: "Y",
                      normal: "",
                      describe: "apiDocDesc.actualQtyDesc186"
                    },
                    {
                      name: "inventoryType",
                      type: "date",
                      require: "Y",
                      normal: "",
                      describe: "apiDocDesc.inventoryTypeDesc187"
                    },
                    {
                      name: "productDate",
                      type: "date",
                      require: "N",
                      normal: "",
                      describe: "apiDocDesc.productDateDesc188"
                    },
                    {
                      name: "expireDate",
                      type: "varchar(50)",
                      require: "N",
                      normal: "",
                      describe: "apiDocDesc.expireDateDesc189"
                    },
                    {
                      name: "produceCode",
                      type: "varchar(50)",
                      require: "N",
                      normal: "",
                      describe: "apiDocDesc.produceCodeDesc190"
                    },
                    {
                      name: "batchCode",
                      type: "",
                      require: "N",
                      normal: "",
                      describe: "apiDocDesc.batchCodeDesc191"
                    }
                  ]
                }
              ]
            }
          ]
        }
      ],
      //参数描述  END
      //报文描述 start
      responseDataList: [
        {
          title: "onlineDoc.响应参数",
          value: [
            {
              name: "success",
              type: "Boolean",
              require: "Y",
              normal: "",
              describe: "apiDocDesc.successDesc192"
            },
            {
              name: "code",
              type: "Number",
              require: "Y",
              normal: "",
              describe: "apiDocDesc.codeDesc193"
            },
            {
              name: "request_id",
              type: "String",
              require: "Y",
              normal: "",
              describe: "apiDocDesc.request_idDesc194"
            },
            {
              name: "message",
              type: "String",
              require: "Y",
              normal: "",
              describe: "apiDocDesc.messageDesc195"
            },
            {
              name: "data",
              type: "Object",
              require: "N",
              normal: "",
              describe: "apiDocDesc.dataDesc196"
            }
          ]
        }
      ],
      //请求示例
      requestCode: {
        confirmType: 0,
        customerId: "MABANG-TEST",
        entryOrderCode: "20240509150212905",
        entryOrderId: "ASN240509635149",
        returnWaybillCode: "JT240509635149",
        wmsCreated: 1,
        deliveryOrderCode: "SO202608150001",
        platformNumber: "585556762624296093",
        operateTime: "2024-05-09T15:04:34",
        orderLines: [
          {
            actualQty: 5,
            batches: [
              {
                actualQty: 5,
                expireDate: "2024-05-06",
                inventoryType: "ZP"
              }
            ],
            expireDate: "2024-05-06",
            id: 7925,
            inventoryType: "ZP",
            itemCode: "123456",
            itemName: "123456",
            lineNo: "1"
          },
          {
            actualQty: 5,
            batches: [
              {
                actualQty: 5,
                expireDate: "2024-05-06",
                inventoryType: "ZP"
              }
            ],
            expireDate: "2024-05-06",
            id: 7926,
            inventoryType: "ZP",
            itemCode: "1234567",
            itemName: "1234567",
            lineNo: "2"
          },
          {
            actualQty: 5,
            batches: [
              {
                actualQty: 5,
                expireDate: "2024-05-06",
                inventoryType: "ZP"
              }
            ],
            expireDate: "2024-05-06",
            id: 7927,
            inventoryType: "ZP",
            itemCode: "001",
            itemName: "001",
            lineNo: "3"
          },
          {
            actualQty: 5,
            batches: [
              {
                actualQty: 5,
                batchCode: "",
                expireDate: "2024-08-06",
                inventoryType: "ZP",
                produceCode: "202405001",
                productDate: "2024-04-30"
              }
            ],
            expireDate: "2024-08-06",
            id: 7928,
            inventoryType: "ZP",
            itemCode: "12345678",
            itemName: "有效期且有批次号",
            lineNo: "4",
            snList: {
              sn: ["931001", "931002"]
            }
          }
        ],
        orderType: "BHRK",
        requestId: "20240509150212905_FULFILLED",
        status: "FULFILLED",
        warehouseCode: "SH.001"
      },
      //返回示例
      responseCode: {
        code: 0,
        message: "成功",
        request_id: "9a53af6aaeb54ceab6637df2c8805369",
        success: true
      }
    }
  };
}
